import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import FruitTable from './FruitTable';
import InfoIcon from "@mui/icons-material/Info";
import OrganizationService from '../organizationService';

function Dropdown(props) {
    const { name, values, selectedValue, handleChange, showColon, sx, orgIdOrUuid } = props;
    const [showTable, setShowTable] = useState(false);
    const [isCorrectOrg, setIsCorrectOrg] = useState(false);

    useEffect(() => {
        const desiredOrgIds = ["21226f00-bdb2-48b1-9145-43f2982916b3", "b951b4f5-7b78-4470-94eb-308c0fba4240", "4e8d1f4b-4346-46cf-a25b-859d41269515"];
        const isOrgCorrect = desiredOrgIds.includes(orgIdOrUuid);
        setIsCorrectOrg(isOrgCorrect);
    }, [orgIdOrUuid]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', position: 'relative' }}>
                <InputLabel
                    id={`${name}-label`}
                    sx={{
                        color: '#000',
                        fontWeight: '800',
                        fontFamily: 'Red Hat Display',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        cursor: 'pointer',
                    }}
                    onClick={() => name === "Fruits" && setShowTable(!showTable)}
                >
                    {name}
                    {name === "Fruits" && isCorrectOrg && (
                        <InfoIcon sx={{ width: '15px', pb: '10px', cursor: 'pointer', color: '#6B6B6B', }} />
                    )}
                </InputLabel>
                {showColon && ':'}
            </div>
            {name === "Fruits" && showTable && isCorrectOrg && <FruitTable onClose={() => setShowTable(false)} />}
            <FormControl variant="standard">
                <Select
                    labelId={`${name}-label`}
                    id={name}
                    value={selectedValue}
                    onChange={handleChange}
                    disableUnderline
                    sx={{
                        '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                        },
                        '& .MuiSelect-root': {
                            border: 'none'
                        },
                    }}
                >
                    {values.map((value) => (
                        <MenuItem key={value} value={value}>
                            {value}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}

export default Dropdown;